import { lazy } from "react"
import { etlRoutes } from "etl/types";

const SelectCompetitor = lazy(() =>
	import("etl/design-system/templates/SelectCompetitor").then(({ SelectCompetitor }) => ({
		default: SelectCompetitor,
	}))
)

const AnalyseLaboratoires = lazy(() =>
	import("etl/design-system/templates/AnalyseLaboratoires").then(({ AnalyseLaboratoires }) => ({
		default: AnalyseLaboratoires,
	}))
)

const UploadFiles = lazy(() =>
	import("etl/design-system/templates/UploadFiles").then(({ UploadFiles }) => ({
		default: UploadFiles,
	}))
)

const Unzip = lazy(() =>
	import("etl/design-system/templates/Unzip").then(({ Unzip }) => ({
		default: Unzip,
	}))
)

const Inspection = lazy(() =>
	import("etl/design-system/templates/Inspection").then(({ Inspection }) => ({
		default: Inspection,
	}))
)

const MergeCsv = lazy(() =>
	import("etl/design-system/templates/MergeCsv").then(({ MergeCsv }) => ({
		default: MergeCsv,
	}))
)

const InputImport = lazy(() =>
	import("etl/design-system/templates/InputImport").then(({ InputImport }) => ({
		default: InputImport,
	}))
)

const ExtractImport = lazy(() =>
	import("etl/design-system/templates/ExtractImport").then(({ ExtractImport }) => ({
		default: ExtractImport,
	}))
)

const DictionaryGenerate = lazy(() =>
	import("etl/design-system/templates/DictionaryGenerate").then(({ DictionaryGenerate }) => ({
		default: DictionaryGenerate,
	}))
)

const BrandDictionary = lazy(() =>
	import("etl/design-system/templates/BrandDictionary").then(({ BrandDictionary }) => ({
		default: BrandDictionary,
	}))
)

const UserDictionary = lazy(() =>
	import("etl/design-system/templates/UserDictionary").then(({ UserDictionary }) => ({
		default: UserDictionary,
	}))
)

const SupplierDictionary = lazy(() =>
	import("etl/design-system/templates/SupplierDictionary").then(({ SupplierDictionary }) => ({
		default: SupplierDictionary,
	}))
)

const CategoryDictionary = lazy(() =>
	import("etl/design-system/templates/CategoryDictionary").then(({ CategoryDictionary }) => ({
		default: CategoryDictionary,
	}))
)

const ProductDictionary = lazy(() =>
	import("etl/design-system/templates/ProductDictionary").then(({ ProductDictionary }) => ({
		default: ProductDictionary,
	}))
)

const ScheduleTypeDictionary = lazy(() =>
	import("etl/design-system/templates/ScheduleTypeDictionary").then(({ ScheduleTypeDictionary }) => ({
		default: ScheduleTypeDictionary,
	}))
)

const OutputData = lazy(() =>
	import("etl/design-system/templates/OutputData").then(({ OutputData }) => ({
		default: OutputData,
	}))
)

const OutputCsv = lazy(() =>
	import("etl/design-system/templates/OutputCsv").then(({ OutputCsv }) => ({
		default: OutputCsv,
	}))
)

const UploadEtlResult = lazy(() =>
	import("etl/design-system/templates/UploadEtlResult").then(({ UploadEtlResult }) => ({
		default: UploadEtlResult,
	}))
)

const TriggerAwInsert = lazy(() =>
	import("etl/design-system/templates/TriggerAwInsert").then(({ TriggerAwInsert }) => ({
		default: TriggerAwInsert,
	}))
)

const TriggerAwAttributeCorrector = lazy(() =>
	import("etl/design-system/templates/TriggerAwAttributeCorrector").then(({ TriggerAwAttributeCorrector }) => ({
		default: TriggerAwAttributeCorrector,
	}))
)

const AllStepCompleted = lazy(() =>
	import("etl/design-system/templates/AllStepCompleted").then(({ AllStepCompleted }) => ({
		default: AllStepCompleted,
	}))
)

export const EtlTunnelMainRouter = [
	{
		path: etlRoutes.selectCompetitor.pathWithoutPrefix,
		component: <SelectCompetitor />,
	},
	{
		path: etlRoutes.etlAnalyseLaboratoires.pathWithoutPrefix,
		component: <AnalyseLaboratoires />,
	},
	{
		path: etlRoutes.etlUploadFiles.pathWithoutPrefix,
		component: <UploadFiles />,
	},
	{
		path: etlRoutes.etlUnzip.pathWithoutPrefix,
		component: <Unzip />,
	},
	{
		path: etlRoutes.etlPreProcess.pathWithoutPrefix,
		component: <Inspection />,
	},
	{
		path: etlRoutes.etlMergeCsv.pathWithoutPrefix,
		component: <MergeCsv />,
	},
	{
		path: etlRoutes.etlInputImport.pathWithoutPrefix,
		component: <InputImport />,
	},
	{
		path: etlRoutes.etlExtractImport.pathWithoutPrefix,
		component: <ExtractImport />,
	},
	{
		path: etlRoutes.etlDictionaryGenerate.pathWithoutPrefix,
		component: <DictionaryGenerate />,
	},
	{
		path: etlRoutes.etlUser.pathWithoutPrefix,
		component: <UserDictionary />,
	},
	{
		path: etlRoutes.etlBrand.pathWithoutPrefix,
		component: <BrandDictionary />,
	},
	{
		path: etlRoutes.etlSupplier.pathWithoutPrefix,
		component: <SupplierDictionary />,
	},
	{
		path: etlRoutes.etlCategory.pathWithoutPrefix,
		component: <CategoryDictionary />,
	},
	{
		path: etlRoutes.etlProduct.pathWithoutPrefix,
		component: <ProductDictionary />,
	},
	{
		path: etlRoutes.etlScheduleType.pathWithoutPrefix,
		component: <ScheduleTypeDictionary />,
	},
	{
		path: etlRoutes.etlOutputData.pathWithoutPrefix,
		component: <OutputData />,
	},
	{
		path: etlRoutes.etlOutputCsv.pathWithoutPrefix,
		component: <OutputCsv />,
	},
	{
		path: etlRoutes.uploadEtlResult.pathWithoutPrefix,
		component: <UploadEtlResult />,
	},
	{
		path: etlRoutes.triggerAwInsert.pathWithoutPrefix,
		component: <TriggerAwInsert />,
	},
	{
		path: etlRoutes.etlAwAttributeCorrector.pathWithoutPrefix,
		component: <TriggerAwAttributeCorrector />,
	},
	{
		path: etlRoutes.allCompleted.pathWithoutPrefix,
		component: <AllStepCompleted />,
	},
];
